module.exports = "<div class=\"animationload w3-animate-opacity\">\n  <div class=\"iconWrapper\">\n    <div class=\"load-icon-wrapper\">\n      <div class=\"osahanloading\"></div>\n    </div>\n    <div class=\"load-msg-wrapper\">\n      <h1 class=\"display-txt\"> {{message}}</h1>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/loading/loading.component.html
// module id = ./src/app/shared/reusable/loading/loading.component.html
// module chunks = main